import { render } from "./tableDetail.vue?vue&type=template&id=bb1cfb46&scoped=true"
import script from "./tableDetail.vue?vue&type=script&lang=js"
export * from "./tableDetail.vue?vue&type=script&lang=js"

import "./tableDetail.vue?vue&type=style&index=0&id=bb1cfb46&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1cfb46"]])

export default __exports__